import axios from "../authApi";

export type LoginResponse = {
  access_token: string;
  email: string;
  is_new_user?: boolean;
  given_name: string;
};

export const login = async (
  credentials: string,
  favoriteClubs?: number[],
  favoriteCountries?: number[],
): Promise<LoginResponse> => {
  const res = await axios.post("/auth/login", {
    token: credentials,
    ...(favoriteClubs?.length && { favoriteClubs }),
    ...(favoriteCountries?.length && { favoriteCountries }),
  });
  localStorage.setItem(
    "access_token",
    JSON.stringify(res.data["access_token"]),
  );
  return res.data;
};
